<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },

    options: {
      type: Array,
      required: true,
    },

    error: {
      type: Boolean,
      default: false,
    },

    blankOption: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showSelect: true,
    }
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
      this.$emit('change')
    },
  },
}
</script>

<template>
  <div class="flex">
    <div v-if="showSelect" class="relative w-full">
      <select
        class="bg-white focus:outline-none border border-gray-300 rounded-l input appearance-none leading-normal w-full"
        :class="{ 'border-error': error }"
        @change="onChange"
      >
        <option
          v-if="blankOption"
          :value="blankOption.id"
          :selected="value === blankOption.id"
        >
          {{ blankOption.label }}
        </option>
        <option
          v-for="option in options"
          :key="option.id"
          :value="option.id"
          :selected="value === option.id"
        >
          {{ option.label }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
    <input
      v-else
      class="bg-white focus:outline-none border border-gray-300 rounded-l input appearance-none leading-normal w-full"
      :class="{ 'border-error': error }"
      @change="onChange"
    />
    <button
      type="button"
      class="w-12 rounded-r bg-gray-300 text-center cursor-pointer"
      @click="showSelect = !showSelect"
    >
      <font-awesome-icon v-if="showSelect" :icon="['fas', 'plus']" />
      <font-awesome-icon v-else :icon="['fas', 'undo']" />
    </button>
  </div>
</template>
